var map = {
	"./fondo/Fondo_Main_menu.png": "1303",
	"./fondo/Grupo30.png": "fcac",
	"./imagenes_compartidas/Cerrar_Ventana.png": "7ad5",
	"./imagenes_compartidas/Flecha_Derecha_Dialogos.png": "ecb9",
	"./imagenes_compartidas/Flecha_Derecha_Paginas.png": "4d2a",
	"./imagenes_compartidas/Flecha_Izquierda_Dialogos.png": "c696",
	"./imagenes_compartidas/Flecha_Izquierda_Paginas.png": "1658",
	"./imagenes_compartidas/abc.png": "79d6",
	"./imagenes_compartidas/boton-info.png": "bb09",
	"./imagenes_compartidas/tucan-0.png": "4dd4",
	"./imagenes_compartidas/tucan-1.png": "5e91",
	"./imagenes_compartidas/tucan-2.png": "dcce",
	"./presentacion/blocked.png": "f8af",
	"./presentacion/diap-1.png": "52db",
	"./presentacion/diap-4-1.png": "26e6",
	"./presentacion/diap-4-2.png": "02ef",
	"./presentacion/diap-9-1.png": "a8d3",
	"./presentacion/unidad-1.png": "3fab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";